<template>
    <div class="pt410" v-cloak>
    <breadcrumb :navListCustom="[{title:$t('common.labels.myPgage'), routerName: pt410Init.myPage, param: {pageNo: '81'}}
        , {title:$t('pt405.labels.title'), routerName: pt410Init.tdkListPage, param: {pageNo: '77'}},
        {title: title2, routerName: '', param: {}}]">
    </breadcrumb>
    <div class="section page-mypage mb32">
        <h2>{{$t('common.labels.myPgage')}}</h2>
        <div class="section-inner">
            <h3>{{title2}}</h3>
            <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="pt410_PART"/>
            <div class="pt-3 pb-3" v-if="report != ''"> <span class="text-danger">{{report}} </span></div>
            <p class="mb16">{{$t('pt410.labels.messg3')}}</p>
                <br>
                <!-- BtoC -->
                <table class="personal mb32"  v-if="pt410Init.siteFlg == 0">
                    <tr>
                        <th class="required">
                            {{$t('common.labels.deliName')}}
                            <div :class="'popup'"></div>
                        </th>
                        <td>
                            <div class="form-column">
                                <!-- 配送先名:姓 -->
                                <template v-if="pt410Init.name2Flg == 1">
                                    <label for="tdkNm1" class="num02">{{$t('pt410.labels.surname')}}</label>
                                </template>
                                <template v-else>
                                    <label for="tdkNm1" class="num02">{{$t('pt410.labels.name1')}}</label>
                                </template>
                                <span id="tdkNm1_lbl" hidden>{{$t('pt410.labels.tdkNm1')}}</span>
                                <!--配送先名を自分宛にするフラグを利用しない場合-->
                                <template v-if="pt410Init.tdkMyAddrFlg == 0">
                                    <input-check :style="pt410Init.name2Flg == 0?'width:150px;':''"
                                            type="text" name="tdkNm1" id="tdkNm1" 
                                            class="form-control-sm" maxlength="50" size="12" 
                                            v-model="pt410Request.tdkNm1" />
                                </template>
                                <!--配送先名を自分宛にするフラグを利用する場合-->
                                <template v-else>
                                    <input-check :style="pt410Init.name2Flg == 0?'width:150px;':''"
                                            disabled style="background-color:#C0C0C0;"
                                            type="text" name="tdkNm1" id="tdkNm1" 
                                            class="form-control-sm" maxlength="50" size="12" 
                                            v-model="pt410Request.tdkNm1" />
                                </template>
                                <!-- 配送先名 -->
                                <template v-if="pt410Init.name2Flg == 1">
                                    <label for="tdkNm2" class="num02">{{$t('pt410.labels.name2')}}</label>
                                    <span id="tdkNm2_lbl" hidden>{{$t('pt410.labels.tdkNm2')}}</span>

                                    <!--配送先名を自分宛にするフラグを利用しない場合-->
                                    <template v-if="pt410Init.tdkMyAddrFlg == 0">
                                        <input-check type="text" name="tdkNm2" id="tdkNm2" class="form-control-sm"  size="12"  maxlength="50" v-model="pt410Request.tdkNm2" />
                                    </template>
                                    <!--配送先名を自分宛にするフラグを利用する場合-->
                                    <template v-else>
                                        <input-check type="text" name="tdkNm2" id="tdkNm2" class="form-control-sm" disabled style="background-color:#C0C0C0;" size="12"  maxlength="50" v-model="pt410Request.tdkNm2" />
                                    </template>
                                </template>
                            </div><!--/ .form-column -->
                            <!--項目説明2 -->
                            <span v-html="descriptionInfo[1]"></span>
                        </td>
                    </tr>
                    <tr>
                        <th v-if="pt410Init.kanaHissuFlg == 0" class="optional">{{$t('common.labels.kanaName')}}</th>
                        <th v-else class="required">{{$t('common.labels.kanaName')}}</th>
                        <td>
                            <div class="form-column">
                                <!-- 配送先名カナ:姓 -->
                                <template v-if="pt410Init.name2Flg == 1">
                                    <label for="tdkKana1" class="num02">{{$t('pt410.labels.surname')}}</label>
                                </template>
                                <template v-else>
                                    <label for="tdkKana1" class="num02">{{$t('pt410.labels.name1')}}</label>
                                </template>
                                <span id="tdkKana1_lbl" hidden>{{$t('pt410.labels.tdkKana1')}}</span>
                                <!--配送先名を自分宛にするフラグを利用しない場合-->
                                <template v-if="pt410Init.tdkMyAddrFlg == 0">
                                    <input-check :style="pt410Init.name2Flg == 0?'width:150px;':''"
                                            type="text" name="tdkKana1" size="12" 
                                            class="form-control-sm" id="tdkKana1" maxlength="50" 
                                            v-model="pt410Request.tdkKana1" />
                                </template>
                                <template v-else>
                                    <input-check :style="pt410Init.name2Flg == 0?'width:150px;':''"
                                            disabled style="background-color:#C0C0C0;"
                                            type="text" name="tdkKana1" size="12" 
                                            class="form-control-sm" id="tdkKana1" maxlength="50" 
                                            v-model="pt410Request.tdkKana1" />
                                </template>
                                <!-- 配送先名カナ:名 -->
                                <template v-if="pt410Init.name2Flg == 1">
                                    <label for="kana2" class="num02">{{$t('pt410.labels.name2')}}</label>
                                    <span id="tdkKana2_lbl" hidden>{{$t('pt410.labels.tdkKana2')}}</span>
                                    <!--配送先名を自分宛にするフラグを利用しない場合-->
                                    <template v-if="pt410Init.tdkMyAddrFlg == 0">
                                        <input-check type="text" name="tdkKana2" size="12" class="form-control-sm" id="tdkKana2" maxlength="50" v-model="pt410Request.tdkKana2" />
                                    </template>
                                    <template v-else>
                                        <input-check type="text" name="tdkKana2" size="12" class="form-control-sm" disabled style="background-color:#C0C0C0;" id="tdkKana2" maxlength="50" v-model="pt410Request.tdkKana2" />
                                    </template>
                                </template>
                            </div><!--/ .form-column -->
                            <span v-html="descriptionInfo[2]"></span>
                        </td>
                    </tr>
                    <tr>
                        <th class="required">
                            <span id="tdkZip_lbl">{{$t('common.labels.postalCode')}}</span>
                        </th>
                        <td>
                            <div class="form-column">
                                <input-check type="text" class="zip form-control-sm" name="tdkZip" size="10" id="tdkZip" maxlength="8" v-model="pt410Request.tdkZip" @on-input-change="addrAutoInput('tdk')"/>
                                <span class="btn_addsearch"><a @click="addrAutoInput('tdk')">{{$t('common.labels.addressSearch')}}</a></span>
                            </div>
                            <span v-html="descriptionInfo[3]"></span>
                        </td>
                    </tr>
                    <!--都道府県 -->
                    <template v-if="pt410Init.kenPulldownDispFlg == 1">
                        <tr>
                            <th class="required">
                                <span id="tdkKenCd_lbl">{{$t('common.labels.prefectures')}}</span>
                            </th>
                            <td>
                                <div class="form-column">
                                    <select v-model="pt410Request.tdkKenCd" class="form-control-sm kenCd" id="tdkKenCd" name="tdkKenCd"> 
                                        <option v-for="kenCd in pt410Init.kenCdList" :key="kenCd.KEY" :value="kenCd.KEY">{{kenCd.VALUE}}</option>
                                    </select>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <input type="hidden" v-model="pt410Request.tdkKenCd" />
                    </template>
                    <!--住所1 -->
                    <tr >
                        <th class="required">
                            <span id="tdkAddr1_lbl">{{$t('pt410.labels.city')}}</span>
                        </th>
                        <td>
                            <input-check type="text" class="form-control-sm" name="tdkAddr1" size="50" id="tdkAddr1" maxlength="100" v-model="pt410Request.tdkAddr1" />
                            &nbsp;<br>
                            <template v-if="pt410Init.kenPulldownDispFlg == 1">
                                <span v-html="descriptionInfo[4]"></span>
                            </template>
                            <template v-else>
                                <span v-html="descriptionInfo[5]"></span>
                            </template>
                        </td>
                    </tr>
                    <!--住所2 -->
                    <tr v-if="pt410Init.addr2Flg == 1">
                        <th class="optional">
                            <span id="tdkAddr2_lbl">{{$t('pt410.labels.lessAddress')}}</span>
                        </th>
                        
                        <td>
                            <input-check type="text" id="tdkAddr2" name="tdkAddr2" size="50" class="form-control-sm" maxlength="100" v-model="pt410Request.tdkAddr2" />
                            &nbsp;<br>
                            <span v-html="descriptionInfo[6]"></span>
                        </td>
                    </tr>
                    <!--住所3 -->
                    <tr v-if="pt410Init.addr3Flg == 1">
                        <th class="optional">
                            <span id="tdkAddr3_lbl">{{$t('common.labels.optionLabel')}}</span>
                        </th>
                        <td>
                            <input-check type="text" id="tdkAddr3" name="tdkAddr3" size="35" class="form-control-sm" maxlength="100" v-model="pt410Request.tdkAddr3" />
                            &nbsp;<br>
                            <span v-html="descriptionInfo[7]"></span>
                        </td>
                    </tr>
                    <tr>
                        <th class="required">
                            <span id="tdkTel1_lbl">{{$t('pt410.labels.phoneNumber')}}</span>
                        </th>
                        <td>
                            <input-check type="text" id="tdkTel1" name="tel1" class="code form-change form-control-sm" size="18" maxlength="15" v-model="pt410Request.tdkTel1" />
                            &nbsp;
                            <span v-html="descriptionInfo[8]"></span>
                        </td>
                    </tr>
                    <tr>
                        <template>
                            <th class="optional" rowspan="2">
                                <span id="tdkMail_lbl">{{$t('common.labels.mail')}}</span>
                            </th>
                        </template>
                        <td>
                            <div class="form-column">
                                <input-check type="text" class="mail form-change mode form-control-sm" id="tdkMail" name="tdkMail" maxlength="100" size="35" v-model="pt410Request.tdkMail" />
                            </div>
                            <span v-html="descriptionInfo[9]"></span>
                        </td>
                    </tr>
                </table>
                <!-- BtoB -->
                <table class="personal mb32"  v-if="pt410Init.siteFlg == 1">
                    <!-- 会社名 -->
                    <tr>
                        <th class="required">
                            <span id="tdkAddr1_lbl">
                                {{$t('pt410.labels.kaishaName')}}
                            </span>
                            <div :class="'popup'"></div>
                        </th>
                        <td>
                            <input-check type="text" class="form-control-sm" name="tdkNm1Comp" size="50" id="tdkNm1Comp" maxlength="50" v-model="pt410Request.tdkNm1Comp" />
                            &nbsp;<br>
                            <span v-html="descriptionInfo[1]"></span>
                            <span id="tdkNm1Comp_lbl" hidden>{{$t('pt410.labels.kaishaName')}}</span>
                        </td>
                    </tr>
                    <!-- 会社名カナ -->
                    <tr>
                        <th v-if="pt410Init.kanaHissuFlg == 0" class="optional">
                            <span id="tdkAddr1_lbl">{{$t('pt410.labels.kaisyamekana')}}</span>
                        </th>
                        <th v-else class="required">
                            <span id="tdkAddr1_lbl">{{$t('pt410.labels.kaisyamekana')}}</span>
                        </th>
                        <td>
                            <input-check type="text" class="form-control-sm" name="tdkKana1Comp" size="50" id="tdkKana1Comp" maxlength="50" v-model="pt410Request.tdkKana1Comp" />
                            &nbsp;<br>
                            <span v-html="descriptionInfo[2]"></span>
                            <span id="tdkKana1Comp_lbl" hidden>{{$t('pt410.labels.kaisyamekana')}}</span>
                        </td>
                    </tr>
                    <!-- 部署名 -->
                    <tr>
                        <th class="optional">
                            <span id="tdkNm2Comp_lbl">{{$t('pt410.labels.bushoName')}}</span>
                        </th>
                        <td>
                            <input-check type="text" class="form-control-sm" name="tdkNm2Comp" size="50" id="tdkNm2Comp" maxlength="50" v-model="pt410Request.tdkNm2Comp" />
                            &nbsp;<br>
                            <span v-html="descriptionInfo[10]"></span>
                            <span id="tdkNm2Comp_lbl" hidden>{{$t('pt410.labels.bushoName')}}</span>
                        </td>
                    </tr>
                    <!-- 担当者名 -->
                    <tr>
                        <th class="optional">
                            <span id="tdkNm3Comp_lbl">{{$t('pt410.labels.tantoshame')}}</span>
                        </th>
                        <td>
                            <input-check type="text" class="form-control-sm" name="TdkNm3Comp" size="50" id="TdkNm3Comp" maxlength="50" v-model="pt410Request.tdkNm3Comp" />
                            &nbsp;<br>
                            <span v-html="descriptionInfo[11]"></span>
                            <span id="tdkNm3Comp_lbl" hidden>{{$t('pt410.labels.bushoName')}}</span>
                        </td>
                    </tr>
                    <!-- 表示敬称 -->
                    <tr>
                        <th class="required">
                            <span id="hyoujiKeisyo_lbl">
                            {{$t("sh030.labels.hyoujiKeisyo")}}
                            </span>
                        </th>
                        <td>
                            <select v-model="pt410Request.hyoujiKeisyo" id="hyoujiKeisyo">
                                <option v-for="ken in pt410Init.hyoujiKeisyoList" :key="ken.KEY" :value="ken.KEY" :selected="ken.KEY == pt410Request.hyoujiKeisyo">{{ken.VALUE}}</option>
                            </select>
                            <br>
                        </td>
                    </tr>
                    <tr>
                        <th class="required">
                            <span id="tdkZipComp_lbl">{{$t('common.labels.postalCode')}}</span>
                        </th>
                        <td>
                            <div class="sendFormColumn">
                                <input-check type="text" class="zip form-control-sm" name="tdkZipComp" size="10" id="tdkZipComp" maxlength="8" v-model="pt410Request.tdkZipComp" @on-input-change="addrAutoInput('tdkComp')"/>
                                <span class="btn_addsearch"><a @click="addrAutoInput('tdkComp')">{{$t('common.labels.addressSearch')}}</a></span>
                            </div>
                            <span v-html="descriptionInfo[3]"></span>
                        </td>
                    </tr>
                    <!--都道府県 -->
                    <template v-if="pt410Init.kenPulldownDispFlg == 1">
                        <tr>
                            <th class="required">
                                <span id="tdkKenCdComp_lbl">{{$t('common.labels.prefectures')}}</span>
                            </th>
                            <td>
                                <div class="sendFormColumn">
                                    <select v-model="pt410Request.tdkKenCdComp" id="tdkKenCd" name="tdkKenCdComp"> 
                                        <option v-for="kenCd in pt410Init.kenCdList" :key="kenCd.KEY" :value="kenCd.KEY">{{kenCd.VALUE}}</option>
                                    </select>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <input type="hidden" v-model="pt410Request.tdkKenCdComp" />
                    </template>
                    <!--住所1 -->
                    <tr>
                        <th class="required">
                            <span id="tdkAddr1Comp_lbl">{{$t('pt410.labels.city')}}</span>
                        </th>
                        <td>
                            <input-check type="text" class="form-control-sm" name="tdkAddr1Comp" size="50" id="tdkAddr1Comp" maxlength="100" v-model="pt410Request.tdkAddr1Comp" />
                            &nbsp;<br>
                            <template v-if="pt410Init.kenPulldownDispFlg == 1">
                                <span v-html="descriptionInfo[4]"></span>
                            </template>
                            <template v-else>
                                <span v-html="descriptionInfo[5]"></span>
                            </template>
                        </td>
                    </tr>
                    <!--住所2 -->
                    <tr v-if="pt410Init.addr2Flg == 1">
                        <th class="optional">
                            <span id="tdkAddr2Comp_lbl">{{$t('pt410.labels.lessAddress')}}</span>
                        </th>
                        
                        <td>
                            <input-check type="text" id="tdkAddr2Comp" name="tdkAddr2Comp" size="50" class="form-control-sm" maxlength="100" v-model="pt410Request.tdkAddr2Comp" />
                            &nbsp;<br>
                            <span v-html="descriptionInfo[6]"></span>
                        </td>
                    </tr>
                    <!--住所3 -->
                    <tr v-if="pt410Init.addr3Flg == 1">
                        <th class="optional">
                            <span id="tdkAddr3Comp_lbl">{{$t('common.labels.optionLabel')}}</span>
                        </th>
                        <td>
                            <input-check type="text" id="tdkAddr3Comp" name="tdkAddr3Comp" size="35" class="form-control-sm" maxlength="100" v-model="pt410Request.tdkAddr3Comp" />
                            &nbsp;<br>
                            <span v-html="descriptionInfo[7]"></span>
                        </td>
                    </tr>
                    <tr>
                        <th class="required">
                            <span id="tdkTel1Comp_lbl">{{$t('pt410.labels.phoneNumber')}}</span>
                        </th>
                        <td>
                            <input-check type="text" id="tdkTel1Comp" name="tel1Comp" class="code form-change form-control-sm" size="18" maxlength="15" v-model="pt410Request.tdkTel1Comp" />
                            &nbsp;
                            <span v-html="descriptionInfo[8]"></span>
                        </td>
                    </tr>
                     <!-- 配達希望時間帯-->
                    <template v-if="pt410Init.hstmKbnDispFlg == 1">
                        <tr>
                            <th >
                                <span>{{$t('common.labels.deliveryHopeJikantai')}}</span>
                            </th>
                            <td>
                                <div class="sendFormColumn">
                                    <select v-model="pt410Request.hstmKbn" id="hstmKbn" name="hstmKbn">
                                        <option v-for="jikantai in pt410Init.jikantaiList" :key="jikantai.KEY" :value="jikantai.KEY">{{jikantai.VALUE}}</option>
                                    </select>                                   
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <input type="hidden" v-model="pt410Request.hstmKbn" />
                    </template>                    
                </table>
                <div class="footerButton">
                    <!--戻るボタン-->
                    <div id="btn_roll3">
                        <input class="submit-button-small" type="submit" :value="$t('common.buttons.return')" @click="backUrl()">
                    </div>
                    <div id="btn_roll2" v-if="pageType == 3">
                        <a class="btnSubmit" @click="confirmDoInsert()">{{$t('common.buttons.signup')}}</a>
                    </div>
                    <div id="btn_roll2" v-if="pageType == 4">
                        <a class="btnSubmit" @click="confirmDoUpdate()">{{$t('common.buttons.update')}}</a>
                    </div>
                </div>
        </div><!--/ .section-inner -->
        <!-- modal confirm area -->
        <alert-confirm 
            v-if="isModalShow"
            :msgConfirm="msgConfirm"
            :okAction="doAction"
            :isButtonCancel="isButtonCancel">
        </alert-confirm>
    </div>
    <CC212 v-if="cc212Dislay" @modal-close="cc212Dislay = false" :propTdkZip1 ="dataCc212.propTdkZip1" :propTdkZip2 ="dataCc212.propTdkZip2" @set-addr-value="setAddrValue"></CC212>
</div>
</template>


<script>
/* eslint-disable */
/*
* Import libs and componnents
*/
import $ from 'jquery';
import axios from "assets/js/request";
import DataTable from 'components/Datatable';
import common from 'assets/js/common';
import BackButton from 'components/BackButton';
import EventBus from 'assets/js/eventBus';
import Message from 'components/MessageEcSite';
import Loading from 'vue-loading-overlay';
import InputCheck from 'components/InputCheck.vue';
import DownloadFile from 'components/DownloadFile';
import AlertConfirm from 'components/AlertConfirm';
import SiteConstants from 'assets/const/SiteConstants.json';
import InputNumber from 'components/InputNumber';
import CC212 from '../search/CC212InputPostal.vue';
import Breadcrumb from "../commonParts/Breadcrumb.vue";

export default {
    /*
    * Name of component
    */
    name: "pt410MemberInfoParts",
    /*
    * Declare props
    */
    props: {
        ptInitData: {
            type: Object,
            default: null,
        }
    },

    /*
    * Declare components
    */
    components: {
        DataTable,
        BackButton,
        Message: Message,
        Loading,
        InputCheck,
        DownloadFile,
        AlertConfirm,
        InputNumber,
        CC212,
        Breadcrumb
    },
    /*
    * Declare variable and set default value
    */
    data: function() {
        return {
            pt410_PART: 'pt410',
            isLoading: false,
            isDisplay: false,
            pt410Init:{
                descriptionInfo:{},
                tdkMyAddrFlg:0
            },
            pt410Request: {
                zip:null,
                zip1:null,
                zip2:null,
                addr1:null,
                addr2:null,
                addr3:null,
                tdkMSeq:null,
                motoPageId:null
            },
            requestBack:{},
            isButtonCancel: true,
            actionFlg:0,
            listIdErr:[],
            SiteConstants: SiteConstants,
            pageType:3,
            isModalShow:false,
            msgConfirm:'',
            listMessValid:[],
            mapMessValid:[],
            report:'',
            cc212Dislay:false,
            dataCc212: {},
            cc212ReqModel:{},
            tdkIndex:null,
            site:"",
            descriptionInfo:[],
            isAddr23Flg: false,
            title2:"",
            errList: []
        }
    },
    /*
    * Initialize
    */
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            _this.pt410Init = _this.ptInitData;
            _this.pt410Request = Object.assign({}, _this.pt410Request, _this.ptInitData.reqModel);
            _this.errList = _this.ptInitData.errList;
        }else{
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT410 + _this.$UrlConstants.DO_INIT,_this.pt410Request).then(function(response) {
                _this.pt410Init = response.data;
                _this.pt410Request = Object.assign({}, _this.pt410Request, response.data.reqModel);
                _this.errList = response.data.errList;
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
        if(_this.pt410Request.tdkMSeq){
            //更新画面
            _this.pageType = 4;
            _this.title2 = this.$i18n.t('pt410.labels.title2');
        }else{
            //登録画面
            _this.pageType = 3;
            _this.title2 = this.$i18n.t('pt410.labels.title1');
        }
        //項目説明
        _this.descriptionInfo = _this.pt410Init.descriptionInfo;
        // エラーメッセージ
        if(_this.errList != null && _this.errList.length > 0){
            _this.displayWarning(_this.errList);
        }
        //close pupup
        EventBus.$on('closed', function() {
            _this.isModalShow = false;
            _this.isAddr23Flg = false;
        });
    },
    /*
    * Methods
    */
    methods: {
        /*
        * 住所２/住所３が利用するそして必須チェック利用が確認する時でメッセージを戻る
        */
        getAddr23Msg: function(){
            let msg = "";
            if ((this.pt410Init.addr2Flg == 1 && this.pt410Init.addr2HissuFlg == 2 && this.pt410Request.tdkAddr2Comp == "") || 
                (this.pt410Init.addr3Flg == 1 && this.pt410Init.addr3HissuFlg == 2 && this.pt410Request.tdkAddr3Comp == "")) {

                let subMsg2 = this.$i18n.t('pt400.labels.lessAddress');
                let subMsg3 = this.$i18n.t('common.labels.optionLabel');

                if ((this.pt410Init.addr2Flg == 1 && this.pt410Init.addr2HissuFlg == 2 && this.pt410Request.tdkAddr2Comp == "") &&  
                    (this.pt410Init.addr3Flg == 1 && this.pt410Init.addr3HissuFlg == 2 && this.pt410Request.tdkAddr3Comp == "")){
                    msg = this.$i18n.t('pt400.labels.messg7').replace("{0}", subMsg2 + "と" + subMsg3);
                }else{
                    if (this.pt410Init.addr2Flg == 1 && this.pt410Init.addr2HissuFlg == 2 && this.pt410Request.tdkAddr2Comp == ""){
                        msg = this.$i18n.t('pt400.labels.messg7').replace("{0}", subMsg2);
                    }
                    if (this.pt410Init.addr3Flg == 1 && this.pt410Init.addr3HissuFlg == 2 && this.pt410Request.tdkAddr3Comp == ""){
                        msg = this.$i18n.t('pt400.labels.messg7').replace("{0}", subMsg3);
                    }
                }
            }
            return msg;
        },
        confirmDoInsert: function(){
            // 住所２/住所３が利用するそして必須チェック利用が確認する時でメッセージを戻る
            let msg = this.getAddr23Msg();
            if (msg != "" && !this.isAddr23Flg){
                this.msgConfirm = msg;
                this.isModalShow = true;
                this.isButtonCancel = true;
                this.actionFlg = 3;
                this.isAddr23Flg = true;
                return;
            }
            
            if (this.isAddr23Flg){
                this.isAddr23Flg = false;
                this.$nextTick(() => {
                    this.isAddr23Flg = false;
                    this.msgConfirm = this.$i18n.t('pt410.labels.messg1')
                    this.isModalShow = true;
                    this.isButtonCancel = true;
                    this.actionFlg = 1;
                });
            }else{
                this.msgConfirm = this.$i18n.t('pt410.labels.messg1')
                this.isModalShow = true;
                this.isButtonCancel = true;
                this.actionFlg = 1;
            }
        },
        /*
        *  add new tdk
        */
        doInsert: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            _this.report = '';
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.pt410_PART);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT410 + _this.$UrlConstants.DO_INSERT, _this.pt410Request).then(function(response) {
                if(response.data.status == 'OK'){
                    _this.backUrl();
                }
                
                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWaring(response.data.errList);
                }
                _this.$emit("event-loading", !true);
            }).catch(function(error) {
                _this.$emit("event-loading", !true);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.pt410_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },

        confirmDoUpdate: function(){
            // 住所２/住所３が利用するそして必須チェック利用が確認する時でメッセージを戻る
            let msg = this.getAddr23Msg();
            if (msg != "" && !this.isAddr23Flg){
                this.msgConfirm = msg;
                this.isModalShow = true;
                this.isButtonCancel = true;
                this.actionFlg = 4;
                this.isAddr23Flg = true;
                return;
            }
            
            if (this.isAddr23Flg){
                this.isAddr23Flg = false;
                this.$nextTick(() => {
                    this.isAddr23Flg = false;
                    this.msgConfirm = this.$i18n.t('pt410.labels.messg2')
                    this.isModalShow = true;
                    this.isButtonCancel = true;
                    this.actionFlg = 2;
                });
            }else{
                this.msgConfirm = this.$i18n.t('pt410.labels.messg2')
                this.isModalShow = true;
                this.isButtonCancel = true;
                this.actionFlg = 2;
            }
        },
        /*
        *  up tdk
        */
        doUpdate: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            _this.report = '';
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.pt410_PART);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT410 + _this.$UrlConstants.DO_UPDATE, _this.pt410Request).then(function(response) {
                if(response.data.status == 'OK'){
                    _this.backUrl();
                }
                
                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWaring(response.data.errList);
                }
                _this.$emit("event-loading", !true);
            }).catch(function(error) {
                _this.$emit("event-loading", !true);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.pt410_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },

        /*
        * 戻るボタン押下処理
        */
        backUrl: function() {
            var _this = this;
            if (this.pt410Request.motoPageId == 'sh040') {
                this.$router.push({ name: this.SiteConstants.PG010MAIN, query: {pageNo: 20}});
            } else {
                const parameter = _this.generateLinkParams(77, _this.pt410Init.tdkListPage, {ptPageNo: _this.requestBack.ptPageNo, ptPageSize: _this.requestBack.ptPageSize});
                _this.$router.push(parameter);
            }
        },
        // ルーターリンクパラメータ設定
        generateLinkParams(pageNo, customUrl, additionalQuery = {}, additionalParams = {}) {
            return common.routerLinkParams(pageNo, customUrl, additionalQuery, additionalParams);
        },
         /*
        *  execute update or delete or insert
        */
        doAction: function(){
            var _this = this;
            switch (_this.actionFlg) {
                case 1:
                    _this.doInsert();
                    break;
                case 2:
                    _this.doUpdate();
                    break;
                case 3:
                    _this.isAddr23Flg = true;
                    _this.confirmDoInsert();
                    break;
                case 4:
                    _this.isAddr23Flg = true;
                    _this.confirmDoUpdate();
                    break;
                default:
                    break;
            }
            // Hide alert confirm
            _this.isModalShow = false;
            _this.actionFlg = 0;
            _this.isButtonCancel = true;
        },
         /*
        * Function stringNvl
        */
        stringNvl: function(strVal, defVal){
            if(strVal==undefined){
                return defVal;
            }else{
                return strVal;
            }
        },
        /* 
        * Function excuteValidation 
        * analyst data message and display
        */
        displayWarning(errorList){
            var idList  = [];
            var mapMsg = [];
            var msgList = [];
            var listIdErr = [];
            // check error list
            if(errorList != null && errorList.length > 0){
                //var errorList = error.response.data.errorList;
                for(var index =0;  index < errorList.length; index ++){
                    // row of table
                    var rowTableIndex = errorList[index].rowTableIndex == undefined ? -1 : errorList[index].rowTableIndex;
                    // zoneIndex
                    var zoneIndex = errorList[index].zoneIndex == undefined ? -1 : errorList[index].zoneIndex;

                    // set border-color for input
                    var listGroupId = errorList[index].groupId;
                    if(listGroupId != null && listGroupId.length > 0){
                        for (var keyInx = 0; keyInx < listGroupId.length; keyInx++){
                            var idInput = listGroupId[keyInx];
                            var inputObj = $('#' + idInput);
                            if(inputObj != null && inputObj != undefined){
                                inputObj.css('border-color', "red");
                            }

                            listIdErr.push(idInput);
                        }
                    }

                    // replace messenge
                    var messageList = errorList[index].messageList;
                    if(messageList != null && messageList.length > 0){
                        for (var mesInx = 0; mesInx < messageList.length; mesInx++){
                            var msgTemp = messageList[mesInx].message;
                            var argList =messageList[mesInx].argList;
                            if(argList != null && argList.length > 0){
                                
                                for(var arg=0; arg<argList.length; arg++){
                                    // get lable display of item input 
                                    var idInput = $('#'+ argList[arg] + '_lbl');
                                    var label ='';

                                    if(idInput != null && idInput != undefined){
                                        label =  idInput.text();
                                    }
                                    // replace text for key to display
                                    if(rowTableIndex > -1){
                                        if(label.length > 0){
                                            msgTemp = msgTemp.replace('{' + argList[arg] + '}', label).replace('{rowIndex}', rowTableIndex);   
                                        }else{
                                            msgTemp = msgTemp.replace('{' + argList[arg] + '}', label);   
                                        }
                                    }else{
                                        if(label.length > 0){
                                            msgTemp = msgTemp.replace('{' + argList[arg] + '}', label);   
                                        }
                                    }
                                }
                            }
                            // if message not include key(message common)
                            if(listGroupId != null && listGroupId.length > 0){
                                var obj ={};
                                obj.key = listGroupId[0];
                                obj.mess= msgTemp;
                                mapMsg.push(obj);
                            }else{
                                msgList.push(msgTemp);
                            }
                            
                        }
                    }
                }

                // emit message to componet message
                var msg ={};
                msg.listMess = msgList;
                msg.mapMsg = mapMsg;
                EventBus.$emit('message', msg);
                return listIdErr;
            }
        },
        addrAutoInput: function(tdkIndex){
            var _this = this;
            _this.tdkIndex = tdkIndex;
            var zip = _this.pt410Request.tdkZip;
            if (_this.tdkIndex == 'tdkComp') {
                zip = _this.pt410Request.tdkZipComp;
            }

            if ( common.isNullItem(zip) ) {
                if (_this.isModalShow != true){
                    _this.isModalShow = true;
                }
				// 郵便番号は必須です。
				_this.msgConfirm =_this.$i18n.t('sh030.labels.zipCodeIsMandatory');
				_this.isButtonCancel = false;
				return;
			}
			var zipArr = zip.split("-");
			var zip1 = "";
			var zip2 = "";
            // 7桁以上の場合
            if ( zip.length >= 7 ) {
                // ハイフンが含まれている場合
                if ( zip.includes("-") ) {
                    zip1 = zipArr[0];
                    zip2 = zipArr[1];
                    // 3桁-4桁でない場合はエラー
                    if (zip1.length != 3 && zip2.length != 4) {
                        _this.isModalShow = true;
                        _this.msgConfirm = _this.$t("sh030.labels.zipCodeDoesNotExist");
                        return;
                    }
                // ハイフンが含まれていない場合
                } else {
                    zip1 = zip.substring(0,3);
                    zip2 = zip.substring(3,7);
                
                    _this.pt410Request.tdkZip = zip1 + "-" + zip2;
                    if (_this.tdkIndex == 'tdkComp') {
                        _this.pt410Request.tdkZipComp = zip1 + "-" + zip2;
                    }
                }
            } else {
                return;
            }
			_this.cc212ReqModel.tdkZip1 = zip1;
			_this.cc212ReqModel.tdkZip2 = zip2;
			_this.$emit("event-loading", true);
			axios.post(_this.$UrlConstants.POPUP + _this.$UrlConstants.CC212 + _this.$UrlConstants.GET_ADDR_INFO, _this.cc212ReqModel).then(function(response) {
				if (response.data.allAddr == 'juufuku'){
					_this.dataCc212.propTdkZip1 = zip1;
					_this.dataCc212.propTdkZip2 = zip2;
					_this.cc212Dislay = true;
				}
				else {
					_this.setAddr(response.data.allAddr ,response.data.kenCd,response.data.kenNm, zip1 ,zip2,tdkIndex);
				}
				_this.$emit("event-loading", !true);
			}).catch(function(error) {
				_this.$emit("event-loading", !true);
				common.errorAPI(error);
			});
		},
		// 住所検索Ajaxの戻り
		// パラメータの_addrに「住所,町名番地,建物名・部屋番号」の形で戻ってくる(30文字ずつ)
		setAddr: function (addr, kenCd , kenNm, zip1 , zip2, tdkIndex){
            var _this = this;
            var sp = new Array("","","");
			if (addr) {
                sp = addr.split(",");
                var displayAddr = sp[0]==null?'':sp[0] ;
                displayAddr += sp[1]==null?'':sp[1];
                displayAddr += sp[2]==null?'':sp[2];
                if(_this.tdkIndex == 'tdk'){
                    //都道府県のプルダウンを使用しない場合
                    if(_this.pt410Init.kenPulldownDispFlg == 0){
                        _this.pt410Request.tdkAddr1 = kenNm + displayAddr;
                    }else{
                        _this.pt410Request.tdkAddr1 = displayAddr;
                    }
                    _this.pt410Request.tdkKenCd = kenCd;
                    _this.pt410Request.tdkZip = zip1+ "-" +zip2;
                }
                if (_this.tdkIndex == 'tdkComp') {
                    //都道府県のプルダウンを使用しない場合
                    if(_this.pt410Init.kenPulldownDispFlg == 0){
                        _this.pt410Request.tdkAddr1Comp = kenNm + displayAddr;
                    }else{
                        _this.pt410Request.tdkAddr1Comp = displayAddr;
                    }
                    _this.pt410Request.tdkKenCdComp = kenCd;
                    _this.pt410Request.tdkZipComp = zip1+ "-" +zip2;
                }
				_this.$forceUpdate();
			}else{
				if (_this.isModalShow != true){
					_this.isModalShow = true;
				}
				// 郵便番号が存在しません
				_this.msgConfirm =_this.$i18n.t('sh030.labels.zipCodeDoesNotExist');
				_this.pt410Request.zip= '';
                _this.pt410Request.zipComp= '';
				_this.isButtonCancel=false;
			}
		},

        setAddrValue:function(data){
            var _this = this;
            var addr1 = data.addr.ALL_ADDR?data.addr.ALL_ADDR:"";
            
            var kenCd = data.kenCd + "";
            //BTOC
            if (_this.pt410Init.siteFlg == 0){
                //都道府県のプルダウンを使用しない場合
                if(_this.pt410Init.kenPulldownDispFlg == 0){
                    _this.pt410Request.tdkAddr1 = addr1;
                }else{
                    _this.pt410Request.tdkAddr1 = _this.outKenNm(kenCd,addr1);
                }
                _this.pt410Request.tdkKenCd = kenCd;

            }else if (_this.pt410Init.siteFlg == 1){
                //BTOB
                //都道府県のプルダウンを使用しない場合
                if(_this.pt410Init.kenPulldownDispFlg == 0){
                    _this.pt410Request.tdkAddr1Comp = addr1;
                }else{
                    _this.pt410Request.tdkAddr1Comp = _this.outKenNm(kenCd,addr1);
                }
                _this.pt410Request.tdkKenCdComp = kenCd;
            }
            
            _this.isCCInputPostalShow = false;
            _this.$forceUpdate();
        },
        /*
        * 都道府県名を削除
        */
        outKenNm :function(kenCd,addr) {
            var kenList = this.pt410Init.kenCdList;
            for ( var i = 0; kenList.length > i; i++) {
                if(kenList[i].KEY == kenCd) {
                    return  addr.replace(kenList[i].VALUE,"");
                }
            }
        },
    },
    /*
    * Excute code after an instance is created
    */
    created: function(){
         var _this = this;
        // Get data from params and query
        var paramData = _this.$route.params;
        if(Object.keys(paramData).length > 0){
            _this.pt410Request.tdkMSeq = paramData.tdkMSeq;
            _this.pt410Request.motoPageId = paramData.motoPageId;
            _this.requestBack.ptPageNo = paramData.ptPageNo;
            _this.requestBack.ptPageSize = paramData.ptPageSize;
        }
    }
    

}
</script>